import React, { useState, useContext } from 'react';
import './preferences.css';
import { setPreferences } from '../../services/apiService';
import { UserContext } from '../userContext/UserContext';

const PreferencesModal = ({ preferences, closeModal }) => {
  const { userId } = useContext(UserContext);

  // State to track updated preferences
  const [localPreferences, setLocalPreferences] = useState({
    Preference1: preferences.Preference1 || '',
    Preference2: preferences.Preference2 || '',
    Preference3: preferences.Preference3 || '',
    Preference4: preferences.Preference4 || '',
    Preference5: preferences.Preference5 || '',
    Preference6: preferences.Preference6 || '',
    Preference7: preferences.Preference7 || '',
    Preference8: preferences.Preference8 || ''
  });

  // Handle input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setLocalPreferences((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      // Convert localPreferences object to an array for the API
      const preferencesArray = [
        localPreferences.Preference1,
        localPreferences.Preference2,
        localPreferences.Preference3,
        localPreferences.Preference4,
        localPreferences.Preference5,
        localPreferences.Preference6,
        localPreferences.Preference7,
        localPreferences.Preference8
      ];
      await setPreferences(userId, preferencesArray);
      alert('Preferences updated successfully!');
      closeModal(); // Close the modal after successful update
    } catch (error) {
      console.error('Error setting preferences:', error);
      alert('Failed to update preferences. Please try again.');
    }
  };

  return (
    <div className="preferences-container">
      <h1>Preferences</h1>
      <form className="pref-form" onSubmit={handleSubmit}>
        <div className="pref-grid">
          <div className="pref-group">
            <label>Preference 1:</label>
            <input 
              type="text" 
              name="Preference1" 
              value={localPreferences.Preference1}
              onChange={handleInputChange}
            />
          </div>
          <div className="pref-group">
            <label>Preference 2:</label>
            <input 
              type="text" 
              name="Preference2" 
              value={localPreferences.Preference2}
              onChange={handleInputChange}
            />
          </div>
          <div className="pref-group">
            <label>Preference 3:</label>
            <input 
              type="text" 
              name="Preference3" 
              value={localPreferences.Preference3}
              onChange={handleInputChange}
            />
          </div>
          <div className="pref-group">
            <label>Preference 4:</label>
            <input 
              type="text" 
              name="Preference4" 
              value={localPreferences.Preference4}
              onChange={handleInputChange}
            />
          </div>
          <div className="pref-group">
            <label>Preference 5:</label>
            <input 
              type="text" 
              name="Preference5" 
              value={localPreferences.Preference5}
              onChange={handleInputChange}
            />
          </div>
          <div className="pref-group">
            <label>Preference 6:</label>
            <input 
              type="text" 
              name="Preference6" 
              value={localPreferences.Preference6}
              onChange={handleInputChange}
            />
          </div>
          <div className="pref-group">
            <label>Preference 7:</label>
            <input 
              type="text" 
              name="Preference7" 
              value={localPreferences.Preference7}
              onChange={handleInputChange}
            />
          </div>
          <div className="pref-group">
            <label>Preference 8:</label>
            <input 
              type="text" 
              name="Preference8" 
              value={localPreferences.Preference8}
              onChange={handleInputChange}
            />
          </div>
        </div>
        <button className="prefs-button" type="submit">Set Preferences</button>
      </form>
    </div>
  );
};

export default PreferencesModal;
